import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getAllValidatorsProject } from '../../../actions/accountActions';

const ValidatorTable = ({ projectId }) => {
  const dispatch = useDispatch();
  const curColumns = [
    {
      title: 'Validator Summary',
      dataIndex: 'name',
      key: 'name',
      showOnResponse: true,
      showOnDesktop: true,
    },
    {
      title: 'Last 24 hours Validation',
      dataIndex: 'last24Validation',
      key: 'last24Validation',
      showOnResponse: true,
      showOnDesktop: true,
    },
    {
      title: 'YTD Avg Validation',
      dataIndex: 'avgValidation',
      key: 'avgValidation',
      showOnResponse: true,
      showOnDesktop: true,
    },
  ];

  const [rowsData, setRowsData] = useState({ columns: curColumns, rows: [] });
  const { validators } = useSelector((state) => state.accountR);

  useEffect(() => {
    if (projectId) {
      dispatch(getAllValidatorsProject(projectId));
    }
  }, [projectId, dispatch]);

  // console.log('validators', validators);
  useEffect(() => {
    if (validators) {
      let data = { ...rowsData };
      data.rows = validators || [];
      setRowsData(data);
    }
  }, [validators]);

  // console.log('rowsData', rowsData);
  return (
    <div className={`col-6 mb-3`}>
      <Table
        columns={rowsData ? rowsData.columns : []}
        dataSource={
          rowsData
            ? rowsData.rows.map((el, idx) => ({
                key: idx,
                ...el,
              }))
            : []
        }
        bordered
        pagination={false}
        mobileBreakPoint={768}
      />
    </div>
  );
};

export default ValidatorTable;
